import r from "./highrise1309.mjs";
function o(t, n) {
  for (var e = t.length; e--; )
    if (r(t[e][0], n))
      return e;
  return -1;
}
export {
  o as default
};
